import { AxiosInstance } from 'axios';
import ErrorLog from '../models/ErrorLog';

export async function getErrorLogData(
  axios: AxiosInstance,
): Promise<ErrorLog[]> {
  const response = await axios.get('/errorLog');
  return response.data.errorLogData;
}
